import { motion } from "framer-motion";
import { useState } from "react";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    mensaje: "",
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://eryndraeventos.es/api/contactanos", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSuccess(true);
        setError(false);
        setFormData({ nombre: "", email: "", mensaje: "" });
      } else {
        throw new Error("Error en el envío");
      }
    } catch (err) {
      setSuccess(false);
      setError(true);
    }
  };
  return (
    
    <motion.section
        id="contacto"
      className="bg-eryndra-hojas bg-cover bg-center text-center py-20 px-6"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      
      <h2 className="text-3xl font-bold mb-8">Contáctanos</h2>
      <form className="max-w-xl mx-auto grid gap-4" onSubmit={handleSubmit}>
        <input className="p-2 rounded bg-eryndra-ivory text-eryndra-forest" 
        name="nombre"
        type="text" 
        placeholder="Nombre" 
        value={formData.nombre}
        onChange={handleChange}
        required />
        <input className="p-2 rounded bg-eryndra-ivory text-eryndra-forest" 
        name="email"
        type="email" 
        placeholder="Correo electrónico" 
        value={formData.email}
        onChange={handleChange}
        required />
        <textarea className="p-2 rounded bg-eryndra-ivory text-eryndra-forest" rows={4} 
        name="mensaje"
        placeholder="Cuéntanos tu idea..." 
        value={formData.mensaje}
        onChange={handleChange}
        required/>
        <button  type="submit" className="btn-eryndra">Enviar mensaje</button>
        {success && (
          <p className="text-green-500 mt-2 text-center">
            ¡Mensaje enviado correctamente!
          </p>
        )}
        {error && (
          <p className="text-red-500 mt-2 text-center">
            Hubo un error al enviar el mensaje.
          </p>
        )}
      </form>
    </motion.section>
  );
}
